const bodyAllowed = ['post', 'put', 'delete', 'patch'];

export const validateArgs = (args, api, verb) => {
  if (args && args.body && !bodyAllowed.includes(verb)) {
    throw new Error(
      `Do not set a body on a ${verb} method. It's happening in call: ${api.service}/${api.endpoint}`,
    );
  }
};
